import { useNavigate } from 'react-router-dom'

import { Box, TagColor as Color, Link, Tag } from '@factorialco/deprecated-design-system'
import {
  PerformanceReviewEvaluation,
  PerformanceReviewEvaluationAnswer,
} from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  evaluation: Pick<PerformanceReviewEvaluation, 'status' | 'id'> & {
    answeredQuestionnairesIdentifier?: Pick<PerformanceReviewEvaluationAnswer, 'id'> | null
  }
  reviewId: number
  targetId: string
  isCheckingOwnResults: boolean
}

export const EvaluationLink = ({
  evaluation: { status, id, answeredQuestionnairesIdentifier },
  reviewId,
  targetId,
  isCheckingOwnResults,
}: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const visibleAnwsers = !!answeredQuestionnairesIdentifier?.id

  switch (status) {
    case 'published':
      if (visibleAnwsers) {
        const link = isCheckingOwnResults
          ? navigation.performanceProcess.reviews.review.myResultsEvaluation.fullPath({
              reviewId: reviewId,
              targetId: targetId ?? '',
              evaluationId: id,
            })
          : navigation.performanceProcess.reviews.review.target.evaluation.fullPath({
              reviewId: reviewId,
              targetId: targetId ?? '',
              evaluationId: id,
            })
        return (
          <Link.Touchable onClick={() => navigate(link)}>
            {i18n.t('performance_process.reviews.target_datatable.review_link.view')}
          </Link.Touchable>
        )
      } else {
        return (
          <Box>
            <Tag inline capitalize type={Color.correct}>
              {i18n.t('performance_process.reviews.target_datatable.review_link.published')}
            </Tag>
          </Box>
        )
      }

    case 'pending':
      return (
        <Box>
          <Tag inline capitalize type={Color.champagne}>
            {i18n.t('performance_process.reviews.target_datatable.review_link.pending')}
          </Tag>
        </Box>
      )
  }
}
